import React from 'react';
import { withApollo } from 'react-apollo';



import {
  XYPlot,
  XAxis,
  YAxis,
  ChartLabel,
  HorizontalGridLines,
  VerticalGridLines,
  LineSeries,
  LineSeriesCanvas,
  LabelSeries,
  DiscreteColorLegend,
  LineMarkSeries,
  Hint
} from 'react-vis';


  class HighRiskSummary extends React.Component {
  
    constructor(props) {
      super(props);
      this.state = { 
        drawMode: 0,
        data: this.props.callDetailsData,
        value: {},
        hoveredItem: false};
      this.mouseOverCall = this.mouseOverCall.bind(this);
      this.onNearestXYCall = this.onNearestXYCall.bind(this);
      this.mouseLeaveCall = this.mouseLeaveCall.bind(this);
      // console.log("inside NtmTrace");
    }
  
  
    mouseOverCall = () => {
      // console.log('mouseOverCallBefore', this.state.value);
      this.setState({ value: false });
      // console.log('mouseOverCallAfter', this.state.value);
    }
  
    mouseLeaveCall = () => {
      // console.log('mouseLeaveCallBefore', this.state.value);
      this.setState({ value: false });
      // console.log('mouseLeaveCallAfter', this.state.value);
    }
  
    onNearestXYCall = (domain, type, inpValue) =>{
      // console.log('onNearestXYCallActual', domain, type, inpValue)
      const simpleDate= new Date(inpValue.x).toLocaleDateString()
      const finalValue = {Date: simpleDate, Type: type, Count : inpValue.y, x:inpValue.x, y:inpValue.y};
      this.setState(({ value }) => ({ value: { ...value, [type]: finalValue } }))
      // console.log('onNearestXYCall', this.state.value);
    }
  
    render() {
      const { callDetailsData } = this.props;
      const { classes } = this.props;
      const colorArray = ['#92A8D1','#6B5B95','#88B04B','#FF6F61','#F7CAC9','#955251','#B565A7'];
      const hintStyle = {
        background: 'black', 
        borderRadius: '10px', 
        padding: '5px'
      };
      // console.log("render", callDetailsData);
      // let data = [];
      // if(callDetailsData.length>0){
      //   data = callDetailsData[0].attemptsData;
      // }
      console.log("test check")
      return (
        <div>
        <label><h3>High Risk Blocked Calls</h3></label>
        <XYPlot xType="time" width={800} height={400} margin={{left: 100, bottom: 100, right:100}}
        onMouseLeave={() => {this.setState({ value: false})}}>
        <HorizontalGridLines />
        <VerticalGridLines />
        <XAxis style={{
            text: {stroke: 'none', fill: '#6b6b76', fontSize: '14px', fontWeight: '600'}
          }} 
          tickFormat={function tickFormat(d){
            const date = new Date(d);
            const dispDate = date.toISOString().substr(5,2) + '/' + date.toISOString().substr(8,2);
            return dispDate
           }} 
           tickTotal={7}/>
        <YAxis style={{
            text: {stroke: 'none', fill: '#6b6b76', fontSize: '14px', fontWeight: '600'}
          }}/>
        <ChartLabel 
          text="Time"
          includeMargin={true}
          xPercent={0.55}
          yPercent={0.63}
          style={{
            textAnchor: 'middle'
          }}
          />
  
        <ChartLabel 
          text="Count"
          includeMargin={true}
          xPercent={0.05}
          yPercent={0.1}
          style={{
            transform: 'rotate(-90)',
            textAnchor: 'middle'
          }}
          />
          {
            callDetailsData.map((callData, index) => {
              const { domain, highRiskData } = callData;
              const hintHighRisk = this.state.value["HighRisk"];
              // console.log({ domain, hintHighRisk});
  
              return [
                      <LineMarkSeries key={"OutLineMarkSeriesHighRisk"+index}
                        className="linemark-series-example"
                        style={{
                          strokeWidth: '3px'
                        }}
                        lineStyle={{stroke: colorArray[index+2]}}
                        markStyle={{stroke: colorArray[index+2]}}
                        // data={[{x: 1, y: 10}, {x: 2, y: 5}, {x: 3, y: 15}]}
                        data = {highRiskData}
                        onMouseLeave={this.mouseLeaveCall}
                        onSeriesMouseOver={this.mouseOverCall}
                        onNearestXY={(value) => this.onNearestXYCall(domain, "HighRisk", value)} 
                        // {...markSeriesProps}
                      />,
                      hintHighRisk ?
                      <Hint key={"HighRisk"+index} value={hintHighRisk || {}} >
                            <div style={hintStyle}>
                              <span>Date : {hintHighRisk.Date} | {hintHighRisk.Type} : {hintHighRisk.Count}</span>
                            </div>
                      </Hint> : null,               
              ];
             }
            )           
          }
        </XYPlot>
        <> 
        {
          callDetailsData.map((callData, index) => {
            const { domain, highRiskData } = callData;
            // console.log(highRiskData[index].legend)
            return(
              <DiscreteColorLegend key= {"LegendHighRisk"+index}
              width={180}
              items={[{title: highRiskData[index].legend, color: colorArray[index+2]}]}
            />
            )
          })
        }
        </>
        </div>
      )
      }
  }

export default (withApollo(HighRiskSummary));
